// TODO hook this up to more pets

import React from 'react';
import { Link } from 'react-router-dom';
import Scroll from 'react-scroll';
import classnames from 'classnames';
import _ from 'lodash';

import BasePage from '../BasePage';
import Pet from '../../../components/Global/Pet';
import Background from '../../../components/Global/Background';
import Arrow from '../../../components/Site/Arrow';
import CatSnapshotFooter from '../../../components/Site/CatSnapshot/CatSnapshotFooter';
import { translateLegacyCat } from '../../../utils/translateLegacyCat';
import getRandom from '../../../utils/getRandom';

const scroll = Scroll.animateScroll;

class CatSnapshot extends BasePage {
	animateScroll() {
		scroll.scrollToBottom();
	}
	getClassNames() {
		const classes = [
			'cat-snapshot',
			`bg--${this.props.bgColor}`,
			this.props.name.special,
		];

		return classnames(classes, {
			'cat-snapshot--screenshot': _.get(this.props, 'location.pathname', '').indexOf('screenshot') > -1,
		});
	}
	render() {
		return (
			<div className={this.getClassNames()}>
				<Background {...this.props}>
					<Pet {...this.props} />
					<div className="server-footer-nudge alt-color--lighter">
						<div className="server-footer-nudge__headline">
							Found with <Link className="site-link" to="/">Tabby Cat</Link>
							<span onClick={this.animateScroll}><Arrow /></span>
						</div>
					</div>
				</Background>
				<CatSnapshotFooter />
			</div>
		);
	}
}

if (window.snapshotCat) {
	CatSnapshot.defaultProps = translateLegacyCat(window.snapshotCat);
} else {
	CatSnapshot.defaultProps = getRandom.cat();
}

export default CatSnapshot;



// WEBPACK FOOTER //
// ./src/routes/Site/CatSnapshot/index.js